module.exports = __webpack_public_path__ + "static/img/09001B_2_C_2020212_LC.002716f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09001B_2_C_2020212_LC.png
// module id = imqQ
// module chunks = 0